import { EllipsisIcon } from "@xola/icons";
import { isEquipmentItem } from "common";
import { uniqueId } from "lodash";
import React, { useMemo, useState } from "react";
import { ExperiencePurchaseItem, PurchaseItemObject } from "types";
import { PurchaseActionMenu } from "../../PurchaseActionMenu";
import { RowData } from "./types";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { isTableView } from "@/stores/dashboardFilterStore";

export const popoverParentId = uniqueId("popoverParentId");

export const ActionCellRenderer = ({ data }: { data: RowData }) => {
    const [isVisible, setIsVisible] = useState(false);
    const isTable = isTableView();

    if ("balance" in data) {
        return null;
    }

    if (!data.isOrganizer && isTable) {
        return null;
    }

    if (!data.isOrganizer && isEquipmentItem(data.item)) {
        return null;
    }

    const handleButtonClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsVisible(true);
    };

    const handleClose = () => setIsVisible(false);

    return (
        <span data-testid="roster-guests-list-action-button">
            <SecondaryButton data-testid="search-result-item-menu" size="tiny" onClick={handleButtonClick}>
                <EllipsisIcon />
            </SecondaryButton>

            {isVisible && (data.item.object === PurchaseItemObject.EXPERIENCE || isEquipmentItem(data.item)) && (
                <DeferredMenu data={data} isVisible={isVisible} onClose={handleClose} />
            )}
        </span>
    );
};

const DeferredMenu = ({ data, isVisible, onClose }: { data: RowData; isVisible: boolean; onClose: () => void }) => {
    const purchase = useMemo(() => {
        if (!("item" in data)) {
            return null;
        }
        const purchaseClone = structuredClone(data.item.purchase);
        const itemIndex = purchaseClone.items.findIndex((item) => item.id === data.item.id);
        purchaseClone.items[itemIndex] = data.item;
        return purchaseClone;
    }, [data]);

    if (
        !purchase ||
        !("item" in data) ||
        (data.item.object !== PurchaseItemObject.EXPERIENCE && !isEquipmentItem(data.item))
    ) {
        return null;
    }

    return (
        <PurchaseActionMenu
            isVisible={isVisible}
            popoverParentId={popoverParentId}
            size="tiny"
            purchase={purchase}
            item={data.item as ExperiencePurchaseItem}
            isOrganizer={!!data.isOrganizer}
            guest={data.guest}
            onClose={onClose}
        />
    );
};
